import { put, select, takeLatest } from '@redux-saga/core/effects'
import { getCrewListSelector } from '../../../features/crew/selectors'
import { ICrewMember } from '../../../features/crew/store/crew.types'
import { throwPcrException } from '../../../features/pcr/store/pcr.actions'
import { PCRConstants } from '../../../features/pcr/store/pcr.constants'
import { sort } from '../../../utilities'
import { setAssessedByOptions } from '../store/procedure.actions'

export function* getAssessedByOptions() {
  try {
    const performedByResponse: [] = yield select(getCrewListSelector)
    const options = performedByResponse.map((crewMember: ICrewMember) => {
      return { id: crewMember.userId?.id, name: crewMember.userId?.name }
    })

    sort(options)
    yield put(setAssessedByOptions(options))
  } catch (e) {
    yield put(throwPcrException(`getAssessedByOptions() error: ${e}`))
  }
}

export function* getAssessedByOptionsSaga() {
  yield takeLatest([PCRConstants.CREATE_PCR], getAssessedByOptions)
}
